import * as React from 'react'
import { Filter, FilterProps } from 'react-admin'
import { UnavailableProductsFiltersArray } from './Filters'

const UnavailableProductsFilters: React.FC<Omit<FilterProps, 'children'>> = (
  props
) => {
  return (
    <Filter {...props}>
      {UnavailableProductsFiltersArray.map((item) => item.FilterInput)}
    </Filter>
  )
}

export default UnavailableProductsFilters
